import { asNullableMeasure, type Measure, type Stored } from "lab-testing-units";
import { SPECIMEN_DEPTH } from "./units";

export type UscsGroup = "SP_SPSM" | "SPSC_SM_SC" | "FINES";

export interface TestIdentificationContract {
  startDate: string | null;
  endDate: string | null;
  specimenReference: string | null;
  // Reads as `number` from any document written before this field carried its unit; the model coerces
  // at construction.
  specimenDepth: Measure | null;
  visualDescription: string | null;
  comment: string | null;
  uscsGroup: UscsGroup | null;
}

export const asTestIdentificationContract = (raw: unknown): TestIdentificationContract => {
  const stored = raw as Stored<TestIdentificationContract>;
  return { ...stored, specimenDepth: asNullableMeasure(stored?.specimenDepth, SPECIMEN_DEPTH) };
};

export const asNullableTestIdentificationContract = (raw: unknown): TestIdentificationContract | null =>
  raw == null ? null : asTestIdentificationContract(raw);
